import { uniqueKey } from 'global/common/keys'
import _ from 'lodash'
import { useMemo } from "react"
import { Breadcrumb } from "semantic-ui-react"

export const useBreadcrumbs = ({ items, onClick }) => {

  const limit = _.size(items)

  const crumbs = useMemo(() => {
    const bcrs = []
    _.forEach(items, (item, index) => {
      if (index < limit) {
        bcrs.push(<Breadcrumb.Section key={uniqueKey('pbc', 'bcs', index)} onClick={() => { onClick(index) }}>{item?.caption}</Breadcrumb.Section>)
        bcrs.push(<Breadcrumb.Divider key={uniqueKey('pbc', 'bsd', index)} />)
      }
    })
    return bcrs
  }, [items])

  if (crumbs && crumbs.length > 0) {
    return <Breadcrumb className={'settings-breadcrumb'}>
      {crumbs}
    </Breadcrumb>
  } else {
    return null
  }
}